import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "previewSection", "previewContent", "confirmButton", "selectCount", "errorSection", "errorMessage"]
  static values = { previewUrl: String, createUrl: String }

  updateSelection() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    const count = checked.length
    this.selectCountTarget.textContent = count

    if (count >= 2) {
      this.confirmButtonTarget.disabled = false
      this.loadPreview(checked.map(cb => cb.value))
    } else {
      this.confirmButtonTarget.disabled = true
      this.previewSectionTarget.style.display = "none"
      this.errorSectionTarget.style.display = "none"
    }
  }

  loadPreview(orderIds) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.previewUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ order_ids: orderIds })
    })
    .then(response => response.json())
    .then(data => {
      if (data.valid) {
        this.errorSectionTarget.style.display = "none"
        this.previewSectionTarget.style.display = "block"

        const priceFormatted = new Intl.NumberFormat('es-AR', {
          style: 'currency', currency: 'ARS', minimumFractionDigits: 0, maximumFractionDigits: 0
        }).format(data.net_price_cents / 100)

        let html = '<div class="p-2 rounded" style="background-color: #f3eaff;">'
        html += '<table class="table table-sm table-borderless mb-2">'
        html += '<tbody>'

        data.combos.forEach(combo => {
          html += `<tr>
            <td><strong>${combo.name}</strong></td>
            <td class="text-center"><span class="badge badge-primary">${combo.count}</span></td>
            <td class="text-right text-muted"><small>${combo.dates.join(', ')}</small></td>
          </tr>`
        })

        html += '</tbody></table>'
        html += `<div class="text-right font-weight-bold" style="color: #6f42c1; font-size: 1.1em;">
          Total: ${priceFormatted}
        </div>`
        html += '</div>'

        this.previewContentTarget.innerHTML = html
        this.confirmButtonTarget.disabled = false
      } else {
        this.previewSectionTarget.style.display = "none"
        this.errorSectionTarget.style.display = "block"
        this.errorMessageTarget.textContent = data.errors.join(', ')
        this.confirmButtonTarget.disabled = true
      }
    })
    .catch(error => {
      this.errorSectionTarget.style.display = "block"
      this.errorMessageTarget.textContent = "Error al obtener preview"
      this.confirmButtonTarget.disabled = true
    })
  }

  submit(event) {
    event.preventDefault()

    const checked = this.checkboxTargets.filter(cb => cb.checked)
    if (checked.length < 2) return

    const orderIds = checked.map(cb => cb.value)
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    // Deshabilitar botón para evitar doble click
    this.confirmButtonTarget.disabled = true
    this.confirmButtonTarget.innerHTML = '<i class="fas fa-spinner fa-spin mr-1"></i> Consolidando...'

    // Crear form y submit
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = this.createUrlValue

    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    orderIds.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'order_ids[]'
      input.value = id
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }
}
